import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useSberPayment } from "../../hooks/useSberPayment";
import { useSberResultState } from "../../hooks/useSberResultState";
import { SberPay } from "../../shared/SberPayConnect";
import { getSberPayFrom3DS } from "../../store/features/sberpay/selectors";
var _ThreeDSPayment = function _ThreeDSPayment(_ref) {
  var onContinue = _ref.onContinue,
    sberPay3DS = _ref.sberPay3DS;
  useSberResultState();
  useSberPayment();
  return sberPay3DS ? /*#__PURE__*/React.createElement(SberPay.Result, {
    onConfirm: onContinue
  }) : null;
};
_ThreeDSPayment.propTypes = process.env.NODE_ENV !== "production" ? {
  onContinue: PropTypes.func,
  sberPay3DS: PropTypes.bool
} : {};

// withRenderFlag не используется по причине того что хуки на проверку
// sberPay3DS вызываются в этом компоненте.

export var ThreeDSPayment = connect(function (state) {
  return {
    sberPay3DS: getSberPayFrom3DS(state)
  };
})(_ThreeDSPayment);